/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAufgabenScopeEnum } from '../../models/lexplus-aufgaben-scope-enum';
import { LexplusAufgabenStatusCountsDto } from '../../models/lexplus-aufgaben-status-counts-dto';

export interface AufgabenControllerFindCountsByStatusV1$Params {
  search?: string;
  standortIDs?: Array<number>;
  standortNichtZugewiesen?: boolean;
  verantwortlicheUserIDs?: Array<string>;
  verantwortlicheFunktionIDs?: Array<number>;
  verantwortlichNichtZugewiesen?: boolean;
  prioritaeten?: Array<number>;
  erlassIDs?: Array<number>;
  terminVon?: string;
  terminBis?: string;
  scope?: LexplusAufgabenScopeEnum;
}

export function aufgabenControllerFindCountsByStatusV1(http: HttpClient, rootUrl: string, params?: AufgabenControllerFindCountsByStatusV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusAufgabenStatusCountsDto>> {
  const rb = new RequestBuilder(rootUrl, aufgabenControllerFindCountsByStatusV1.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('standortIDs', params.standortIDs, {});
    rb.query('standortNichtZugewiesen', params.standortNichtZugewiesen, {});
    rb.query('verantwortlicheUserIDs', params.verantwortlicheUserIDs, {});
    rb.query('verantwortlicheFunktionIDs', params.verantwortlicheFunktionIDs, {});
    rb.query('verantwortlichNichtZugewiesen', params.verantwortlichNichtZugewiesen, {});
    rb.query('prioritaeten', params.prioritaeten, {});
    rb.query('erlassIDs', params.erlassIDs, {});
    rb.query('terminVon', params.terminVon, {});
    rb.query('terminBis', params.terminBis, {});
    rb.query('scope', params.scope, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusAufgabenStatusCountsDto>;
    })
  );
}

aufgabenControllerFindCountsByStatusV1.PATH = '/v1/aufgaben/paginated/counts-by-status';
